import { prepareRespSRPURL, prepareSeatLayoutURL } from '../utils';
import dateformat from 'dateformat';
import getDateObj from './GetDateObj';

export const redirectToFunnel = (props) => {
    const { page = 'home', prefillData = false, data = {}, data_date = dateformat(getDateObj(), 'yyyymmdd'), selectedFilters = {},section='', rtcId = '', routeId = '', viewMoreBuses = false, sortBy = '', isFilter = false, isCategoryPage = false, rtcOfferClick=false, operatorName = '', operatorId = ''  } = props;

    let url = `${__ENV_CONFIG__.__GOIBIBO__}`

    const src = data.src_name ? data.src_name : data.src ? data.src : '';
    const dest = data.dest_name ? data.dest_name : data.dest ? data.dest : '';
    const src_id = data.src_id ? data.src_id : data.src_vid ? data.src_vid : '';
    const dest_id = data.dest_id ? data.dest_id : data.dest_vid ? data.dest_vid : '';

    switch (page) {
        case 'home':
            url += `/bus/`;
            if (prefillData) {
                url += `?page_source=seo&src=${src}&dest=${dest}&src_id=${src_id}&dest_id=${dest_id}&onwDate=${data_date}`;
            }
            if (prefillData && isCategoryPage) {
                const { busType = "" } = selectedFilters;
                if (busType) {
                    url += `&busType=${busType.join("|")}`
                }
            }
            break;
        case 'srp':
            url += `${prepareRespSRPURL({
                src,
                dest,
                src_id,
                dest_id,
                date: data_date,
                isFilter,
                selectedFilters,
                rtcId,
                routeId,
                viewMoreBuses,
                sortBy,
                operatorId,
                operatorName
            })}`;
            if(section){
                url+=`&section=${section}`
            }
            if(rtcOfferClick){
                 url += `&rtcOfferClick=${rtcOfferClick}`
            }
            break;
        case 'seatlayout':
            url += `${prepareSeatLayoutURL({
                data: data,
                src,
                dest,
                src_id,
                dest_id,
                onwDate: data_date,
            })}`;
            break;
        default:
            url += `/bus/`;
            break;
    }
    window.location.href = url;
}
